var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEventSuccess = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "5 6 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop-User-Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-User-Profile---Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Location-/-Black-Background"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.000000, 7.000000)",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8971292,1.40909091 L13.8971292,14.5 L-0.5,14.5 L-0.5,1.40909091 L13.8971292,1.40909091 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.45830622,
    y1: 3.03227273,
    x2: 2.45830622,
    y2: 4.19664303e-14,
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.2135311,
    y1: 3.03227273,
    x2: 11.2135311,
    y2: 4.19664303e-14,
    id: "Stroke-4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -2.04281037e-14,
    y1: 4.17950909,
    x2: 13.6724402,
    y2: 4.17950909,
    id: "Stroke-5"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-7",
    stroke: "currentColor",
    points: "13 16.0073157 15.0995851 18 18 13"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEventSuccess, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/eventSuccess.887a4a4f.svg";
export { ForwardRef as ReactComponent };